import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "../../lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { TextAlignMenuContent } from "./TextAlignMenuContent";

interface TextAlignMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function TextAlignMenu({ activeSubMenu, setActiveSubMenu }: TextAlignMenuProps) {
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);
    const options = useAtomValue(widgetMenuOptionsByNameAtom("textAlign"));

    const handleButtonClick = useCallback(
        (align: string) => {
            const setNewTextAlignOptions = setNewOptions({
                name: "textAlign",
                setWidgetMenuOptions,
            });

            function handleClose() {
                setActiveSubMenu(null);
            }

            applyValue({
                options: options,
                value: align,
                setNewOptions: setNewTextAlignOptions,
                handleClose,
            });
        },
        [options, setWidgetMenuOptions, setActiveSubMenu],
    );

    return (
        <SubMenu activeSubMenu={activeSubMenu}>
            <TextAlignMenuContent onTextAlignButtonClick={handleButtonClick} />
        </SubMenu>
    );
}
